<template>
  <div id="post-list-editor">
    <v-row justify="end" class="mb-3">
      <v-btn class="mr-3" color="success" @click="addPostDialog = true">
        記事を追加する
        <v-icon right> mdi-plus</v-icon>
      </v-btn>
    </v-row>
    <post-gallary
      :post-gallary="addPostDialog"
      :selectdPostIds="postIds"
      @close-post-gallary="addPostDialog = false"
      @select-post="selectPost"
    />

    <v-simple-table class="mb-3">
      <thead>
        <tr>
          <th class="col-1"></th>
          <th class="col-1">表示順</th>
          <th class="col-1">slug</th>
          <th class="col-2"></th>
          <th class="col-4">記事タイトル</th>
          <th class="col-4">カテゴリ</th>
          <th class="col-2"></th>
        </tr>
      </thead>

      <draggable
        v-model="postListItems"
        class="p-postListRow__block"
        ghost-class="p-postListRow__block--ghost"
        tag="tbody"
        handle=".p-postListRow__block--dragging-handle"
        :scroll-sensitivity="200"
        :force-fallback="true"
        :animation="200"
      >
        <tr
          v-for="(item, index) in postListItems.filter((item) => !item._destroy)"
          :key="item.id"
          class="p-postListRow__block"
        >
          <td class="col-1 text-center p-postListRow__block--dragging-handle">
            <v-icon class="">mdi-view-headline</v-icon>
          </td>
          <td class="col-1">{{ index + 1 }}</td>
          <td class="col-1">
            <a :href="`/preview/${item.post.id}`" target="_blank">/{{ item.post.slug }}</a>
          </td>
          <td class="col-2">
            <v-img :src="eyecatchableSrc(item.post)" height="100" max-width="100" />
          </td>
          <td class="col-4">{{ item.post.title }}</td>
          <td class="col-2">{{ item.post.category ? item.post.category.name : '' }}</td>
          <td class="col-2">
            <div>
              <v-btn color="red" outlined dark medium @click="removePostList(item.id)">記事グループから外す</v-btn>
            </div>
          </td>
        </tr>
      </draggable>
    </v-simple-table>

    <v-btn color="primary" class="float-right" @click="savePostList">
      保存
    </v-btn>
  </div>
</template>

<script>
import headUtilsMixin from '@/mixins/head_utils'
import PostGallary from '@/components/commons/PostGallary'
import draggable from 'vuedraggable'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  props: ['groupRole'],
  components: { PostGallary, draggable },
  mixins: [headUtilsMixin],
  computed: {
    postIds () {
      let ids = []
      this.postListItems.forEach((post) => {
        if (post._destroy === false) {
          ids.push(post.post.id)
        }
      })
      return ids
    },
    eyecatchableSrc () {
      return function (post) {
        if (post.eyecatchable) {
          return post.eyecatchable.file.middle.url
        } else {
          return 'http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image'
        }
      }
    }
  },
  data () {
    return {
      pageTitle: `記事グループの編集`,
      postListItems: [],
      addPostDialog: false
    }
  },
  mounted () {
    this.fetchPostList()
  },
  methods: {
    selectPost (post) {
      const postIdAndDestroys = this.postListItems.map((item) => {
        return { ...item, _destroy: item._destroy }
      })
      const checkOldPost = postIdAndDestroys.find(
        (item) => item.post.id === post.id && !post._destroy
      )
      if (checkOldPost) {
        const payload = {
          status: 500,
          message: 'この記事はすでに選択されています。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      } else {
        if (post._destroy) {
          post._destroy = false
        }
        this.postListItems = this.postListItems.filter(
          (item) => item.post.id !== post.id
        )
        this.postListItems.push({
          postId: post.id,
          post: post,
          isFixed: false,
          _destroy: false
        })
      }
    },
    removePostList (itemId) {
      this.postListItems = this.postListItems.map((item) => {
        if (item.id === itemId) {
          item._destroy = true
        }
        return item
      })
    },
    fetchPostList () {
      axios.get(`/api/post_lists/${this.groupRole}/edit`).then(
        ({ data }) => {
          this.postListItems = deserialize(data).data.postListItems || []
          this.postListItems.sort((prev, next) => {
            if (prev.order > next.order) return 1
            if (prev.order < next.order) return -1
          })
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    savePostList () {
      if (this.postListItems.length === 0) {
        const payload = {
          status: 400,
          message: '1つ以上の記事を必ず選択してください'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        return false
      }

      const postListItemsAttributes = this.postListItems.map((item, index) => {
        return {
          id: item.id,
          order: index,
          post_id: item.postId,
          is_fixed: false,
          _destroy: item._destroy
        }
      })
      const query = {
        post_list: {
          postListItems_attributes: postListItemsAttributes
        }
      }
      axios
        .patch(`/api/post_lists/${this.groupRole}`, query)
        .then(
          ({ data }) => {
            const payload = {
              status: 200,
              message: '変更を保存しました'
            }
            this.fetchPostList()
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>
